import {PushNotificationsRepository} from "../../domain/repository/push-notifications-repository";
import {Injectable} from "@angular/core";
import {DeviceDAO} from "../device.dao";
import {DeviceWS} from "../device.ws";
import {Observable} from "rxjs";
import {tap} from "rxjs/internal/operators/tap";

@Injectable()
export class PushNotificationsDataRepository implements PushNotificationsRepository {
  constructor(
    private deviceDAO: DeviceDAO,
    private deviceWS: DeviceWS,
  ) {
  }

  /**
   * Creates a device. First save it, then try to send it
   * @param deviceId: new device identifier
   */
  createDeviceId(deviceId: string): void {
    // Create a device as not sent
    this.storeDevice(deviceId);
    this.markAsSent(deviceId, false);

    // Try to send it
    this.sendDeviceId(deviceId).subscribe();
  }
  createPendingDevice(): void {

    const pendingDevice = this.deviceDAO.notSentDevice();

    if (pendingDevice == null) {
      //If there is no pending device does nothing
      return;
    }

    this.sendDeviceId(pendingDevice.identifier).subscribe();
  }

  /**
   * Stores a deviceId if not exists to allow send it later
   * @param deviceId: device identifier
   */
  protected storeDevice(deviceId: string): void {
    if (!this.deviceDAO.exists(deviceId)) {
      this.deviceDAO.create(deviceId);
    }
  }

  protected sendDeviceId(deviceId: string): Observable<void> {
    return this.deviceWS.execute(deviceId).pipe(
      // If the device is sent, mark it as sent
      tap(() => this.markAsSent(deviceId, true)),
    )
  }

  protected markAsSent(deviceId: string, isSent: boolean): void {
    this.deviceDAO.update(deviceId, isSent);
  }
}
